module.exports = __webpack_public_path__ + "static/img/6.88c5439.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/6.png
// module id = WC51
// module chunks = 0